export default {"src":"/_next/static/media/Read.012a7ff6.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};